import axiosInstance from "../api";
import {
  GET_ACTIVE_POST,
  GET_CANCELLED_MINE_UMB_POSTS,
  GET_COMPLETD_MINE_POSTS,
  GET_COMPLETD_MINE_UMB_POSTS,
  GET_DEACTIVE_POST,
  GET_FILTERD_POSTS,
  GET_FILTER_POSTS,
  GET_MINE_POSTS,
  GET_PBP_BY_ID,
  GET_POSTS,
  GET_POSTS_BY_ID,
  GET_POSTS_COUNT,
  GET_PROPOSED_POST,
  GET_SIMILAR_POSTS,
} from "../constants";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";
import { getProfile } from "../profile/action";

export const getPosts = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `post?type=${type ? type : ""}`
    );
    if (response?.data?.status) {
      dispatch({ type: GET_POSTS, postlist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const addtowishlist = (id, data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post/wishlist?id=${id}&wishlist=1`);
    if (response?.data?.status) {
      dispatch(FilterPostListings(data));
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const addtowishinpostbyid = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post/wishlist?id=${id}&wishlist=1`);
    if (response?.data?.status) {
      // dispatch(getPostsById(id));
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const addtowishinpostbyidindashboard = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post/wishlist?id=${id}&wishlist=1`);
    if (response?.data?.status) {
      // dispatch(getDashboard())
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const addtowishinrecentpost = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post/wishlist?id=${id}&wishlist=1`);
    if (response?.data?.status) {
      dispatch(getPostListings());
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const addproposaltowishlist = (id, posts_id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `proposal/wishlist?id=${id}&wishlist=1`
    );
    if (response?.data?.status) {
      dispatch(getPostsById(posts_id));
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getPostListings = (category_id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `post?category_id=${category_id ? category_id : ""}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_FILTER_POSTS,
        getpostlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getSimilarPostListings =
  (type, category_id, selected_id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `post?type=${type ? type : ""}&selected_id=${selected_id ? selected_id : ""}&category_id=${category_id ? category_id : ""
        }`
      );
      if (response?.data?.status) {
        dispatch({
          type: GET_SIMILAR_POSTS,
          getsimilarpostlist: response?.data?.response,
        });
        return;
      }
      urtoast(response?.data?.response?.message, 2);
    } catch (err) {
      //urtoast(err.message, 2);
    }
  };

export const getMinePosts = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post?type=${type}&is_mine=1`);
    if (response?.data?.status) {
      dispatch({
        type: GET_MINE_POSTS,
        postlistmine: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getCompletesMinePosts = (type, status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `post?type=${type}&is_mine=1&status=${status}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_COMPLETD_MINE_POSTS,
        completedpostlistmine: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getUmbrellaCompletesMinePosts =
  (type, status) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `post?type=${type}&is_mine=1&status=${status}&is_ambrella=1`
      );
      if (response?.data?.status) {
        dispatch({
          type: GET_COMPLETD_MINE_UMB_POSTS,
          completedumbrellapostlistmine: response?.data?.response,
        });
        return response?.data;
      }
      urtoast(response?.data?.response?.message, 2);
      return response?.data;
    } catch (err) {
      //urtoast(err.message, 2);
    }
  };

export const getUmbrellaCancelledMinePosts =
  (type, status) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `post?type=${type}&is_mine=1&status=${status}&is_ambrella=1`
      );
      if (response?.data?.status) {
        dispatch({
          type: GET_CANCELLED_MINE_UMB_POSTS,
          cancelledumbrellapostlistmine: response?.data?.response,
        });
        return response?.data;
      }
      urtoast(response?.data?.response?.message, 2);
      return response?.data;
    } catch (err) {
      //urtoast(err.message, 2);
    }
  };

export const reportPost = (master_id, master_type) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("report", {
      master_id,
      master_type,
    });
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      return response?.data;
    }
    urtoast(response?.data?.response?.message, 2);
    return response?.data;
  } catch (err) {
    urtoast(err?.message, 2);
  }
};

export const addPosts = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("post/create", data);
    if (response?.data?.status) {
      setLoading(false);
    

      dispatch(getPosts());
      urtoast(response?.data?.response?.message, 1);
      window.location.reload();
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const updatePosts = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("post/update", data);
    if (response?.data?.status) {
      setLoading(false);
      urtoast(response?.data?.response?.message, 1);
      dispatch(getPosts());
      window.location.reload();
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};

export const deletePosts = (id, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.delete(`post/delete?id=${id}`);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getPosts());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};

export const getPostsById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post/id?id=${id}`);
    if (response?.data?.status) {
    
      dispatch({ type: GET_POSTS_BY_ID, postbyid: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};


export const getPBPUmbrellaById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post?parent_id=${id}`);
    if (response?.data?.status) {
       
      dispatch({ type: GET_PBP_BY_ID, pbpbyid: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};



export const getPostsCancelById = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.put(`post/update/status`, data);
    dispatch(getPostsById(data?.post_id));
    dispatch(getProfile());
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const FilterPostListings = (data) => async (dispatch) => {

  try {
    const response = await axiosInstance.post("post", data);
    if (response?.data?.status) {
      dispatch({ type: GET_FILTERD_POSTS, getfilterdpost: response.data });
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);

  } catch (err) {

    console.error();
    //urtoast(err.message, 2);
  }
};

export const getProposedPostList = (type) => async (dispatch) => {

  const data = {
    proposed: "1",
    type: type,
    method: "GET",
  };
  try {
    const response = await axiosInstance.post("post", data);
    if (response?.data?.status) {
      dispatch({
        type: GET_PROPOSED_POST,
        getproposedpostlist: response?.data?.response,
      });
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);

  } catch (err) {

    console.error();
    //urtoast(err.message, 2);
  }
};

export const getActivePostList = (type) => async (dispatch) => {

  const data = {
    status: "2",
    type: type,
    method: "GET",
  };
  try {
    const response = await axiosInstance.post("post", data);
    if (response?.data?.status) {
      dispatch({
        type: GET_ACTIVE_POST,
        getactivepostlist: response?.data?.response,
      });
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);

  } catch (err) {

    console.error();
    //urtoast(err.message, 2);
  }
};

export const getInActivePostList = (type) => async (dispatch) => {

  const data = {
    status: "3",
    type: type,
    method: "GET",
  };
  try {
    const response = await axiosInstance.post("post", data);
    if (response?.data?.status) {
      dispatch({
        type: GET_DEACTIVE_POST,
        getdeactivepostlist: response?.data?.response,
      });
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);

  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getPostCounts = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`count?type=${type}`);
    if (response?.data?.status) {
      dispatch({ type: GET_POSTS_COUNT, postcounts: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    // //urtoast(err.message, 2);
  }
};

export const postsCancelByIdAPI = (data) => async (dispatch) => {

  try {
    const response = await axiosInstance.put(`post/update/status`, data);
    dispatch(getPostsById(data?.post_id));
    dispatch(getProfile());
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};
